const initialState = {
    user: {
        id: null,
        username: null,
        name: null,
        email: null,
        is_admin: false,
    },
    token: null,
    isAuthenticated: false,
};

export const authReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case "LOGIN":
            console.log("STATE:", state);
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.isAuthenticated = true;
            break; 
        case "LOGOUT":
            console.log("STATE:", state);
            state.user = initialState.user;
            state.token = null;
            state.isAuthenticated = false;
            break;
        default:
            console.log("State", state);
    }
    return state;
};